import { INoRowsOverlayAngularComp } from '@ag-grid-community/angular';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconComponent } from '@shared/components/icon/icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  selector: 'aux-investigator-forecast-table-now-rows-overlay',
  template: `
    <div class="flex w-full items-center space-x-2" style="pointer-events: auto !important">
      <aux-icon name="User" [size]="30" />
      <span class="text-2xl font-bold">No enrolled patients</span>
    </div>
  `,
})
export class InvestigatorForecastTableNowRowsOverlayComponent implements INoRowsOverlayAngularComp {
  agInit(): void {}

  refresh(): boolean {
    return false;
  }
}
